// src/hooks/useToast.ts
import { toast, type ToastOptions } from 'react-toastify';

const defaultOptions: ToastOptions = {
  position: 'bottom-right',
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  className: 'toastify-custom',
};

export function useToast() {
  const success = (msg: string, options?: ToastOptions) =>
    toast.success(msg, { ...defaultOptions, ...options });

  const error = (msg: string, options?: ToastOptions) =>
    toast.error(msg, { ...defaultOptions, ...options });

  const info = (msg: string, options?: ToastOptions) =>
    toast.info(msg, { ...defaultOptions, ...options });

  const warning = (msg: string, options?: ToastOptions) =>
    toast.warning(msg, { ...defaultOptions, ...options });

  return { success, error, info, warning };
}
